var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticStyle:{"overflow-x":"hidden","overflow-y":"auto"},attrs:{"dense":"","max-height":"128"}},_vm._l((_vm.cards),function(card,i){return _c('savedCreditCard',{key:i,attrs:{"card":card,"index":i,"disabled":_vm.disabled},on:{"closeAndRefresh":function($event){return _vm.$emit('closeAndRefresh', 'update')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }